<template>
  <v-container id="data-tables" tag="section" fluid>
    <base-material-card color="primary" icon="mdi-trash-can-outline" inline class="ml-0 px-5 py-4">
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">Remover Georreferenciado</div>
      </template>

      <v-btn
        id="btn-novo-expurgo"
        color="success"
        dark
        elevation="1"
        class="mt-5"
        style="float: left"
        relative
        text
        medium
        @click="$router.push(`adicionar`)"
      >
        <v-icon left size="30px">mdi-plus-circle</v-icon>
        NOVO EXPURGO
      </v-btn>

      <v-text-field
        id="removedor-georreferenciado-historico-search"
        v-model="search"
        append-icon="mdi-magnify"
        class="break-search ml-auto mt-4"
        label="Procurar"
        hide-details
        single-line
        style="max-width: 265px"
      />

      <v-divider class="mt-10" />

      <v-data-table
        :headers="headers"
        :items="items"
        :search.sync="search"
        no-data-text="Nenhum expurgo encontrado"
        no-results-text="Nenhum registro correspondente encontrado"
        :headerProps="{ sortByText: 'Ordenar Por' }"
        :footer-props="{ itemsPerPageText: 'Itens por Página' }"
        mobile-breakpoint="800"
        :loading="loading"
      >
        <template v-slot:[`item.id`]="{ item }">{{ item.id }}</template>
        <template v-slot:[`item.tabelas`]="{ item }">
          <span class="size-dialog" style="color: #e5502c">
            <a @click="openDialog(item, 'Tabelas')">
              {{ item.qtdtabelas }}
            </a>
          </span>
        </template>
        <template v-slot:[`item.numero_linhas`]="{ item }">{{ item.numero_linhas | parseNumberToIntegerBR }}</template>
        <template v-slot:[`item.datas_versoes`]="{ item }">
          <span class="size-dialog" style="color: #e5502c">
            <a @click="openDialog(item, 'Datas')">
              {{ item.qtdDataVersoes }}
            </a>
          </span>
        </template>
        <template v-slot:[`item.usuario`]="{ item }">{{ item.usuario.nome }}</template>
        <template v-slot:[`item.data_execucao`]="{ item }">{{ item.executado_em | parseToDateTimeBR }}</template>
        <template v-slot:[`item.status`]="{ item }">
          <general-status :status="item.status" />
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-btn
            v-if="canDeleteItem(item)"
            id="action-excluir-expurgo"
            min-width="0"
            class="ml-n1 px-1"
            fab
            icon
            x-small
            @click="openDialogDelete(item.id, item.nome)"
          >
            <v-icon small>mdi-trash-can-outline</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </base-material-card>

    <dialog-delete
      :showDialog="dialogDelete"
      @changeValue="dialogDelete = $event"
      @deleteTriggered="deletarItem(dialogDeleteData.id)"
    >
      <template slot="title">
        <span style="word-break: break-word">Deletar Expurgo Georreferenciado #{{ dialogDeleteData.id }}</span>
      </template>
      <template slot="body">
        Tem certeza que deseja deletar o Expurgo dos Registros Georreferenciado
        <strong>{{ dialogDeleteData.titulo }}</strong>
        ?
      </template>
    </dialog-delete>

    <dialog-datas-tabelas :items="itemDialog" :tipo="tipoDialog" :showDialog="showDialog" @changValue="showDialog = $event" />
  </v-container>
</template>

<script>
  import RemoverGeorreferenciadoService from '@/services/RemoverGeorreferenciadoService.js';
  import powerupsActionsMixins from '@/mixins/powerupsActionsMixins.js';

  export default {
    components: {
      DialogDelete: () => import('@/components/general/DialogDelete'),
      GeneralStatus: () => import('@/components/general/GeneralStatus.vue'),
      DialogDatasTabelas: () => import('@/components/removedorGeorreferenciado/DialogDatasTabelas')
    },
    mixins: [powerupsActionsMixins],

    props: {
      items: {
        type: Array,
        default: () => []
      },
      loading: {
        type: Boolean,
        default: false
      }
    },

    data: () => ({
      search: '',
      powerupService: RemoverGeorreferenciadoService,
      powerupEntityName: 'Expurgo Georreferenciado',
      showDialog: false,
      itemDialog: {},
      tipoDialog: '',
      headers: [
        {
          text: '#',
          value: 'id'
        },
        {
          text: 'Tabelas',
          value: 'tabelas'
        },
        {
          text: 'Datas e Versões',
          value: 'datas_versoes'
        },
        {
          text: 'Nº de Linhas',
          value: 'numero_linhas'
        },
        {
          text: 'Usuário',
          value: 'usuario'
        },
        {
          text: 'Executado',
          value: 'data_execucao'
        },
        {
          text: 'Status',
          value: 'status'
        },
        {
          sortable: false,
          text: 'Ações',
          value: 'actions',
          class: 'pl-4'
        }
      ]
    }),

    methods: {
      openDialog(item, tipo) {
        this.itemDialog = item;
        this.tipoDialog = tipo;
        this.showDialog = true;
      }
    },

    watch: {
      items() {
        this.tratarJson();
      }
    }
  };
</script>
<style>
  .size-dialog {
    font-size: 0.95rem !important;
    font-weight: normal !important;
    cursor: pointer;
  }
</style>
